import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const ReportsImage = props => (
    <SvgIcon {...props}>
        <path
            d="M10.39 2l4.611 2.656L16 8.383v2.272l-1.458-5.443-3.476.932-.929-3.467-6.372 1.708L6.877 16h-.61L3.045 3.968 10.39 2zM16 14.11v.609L11.218 16H8.943L16 14.11zm-1.374-1.766l.152.569-6.344 1.7-.153-.569 6.345-1.7zm-.56-2.085l.153.569-6.344 1.7-.153-.569 6.345-1.7zm-.532-1.99l.152.568-6.344 1.7-.153-.568 6.345-1.7zM13 6.279l.153.568-6.345 1.7-.152-.569L13 6.278zM8.938 5.131l.152.569-2.935.786-.153-.569 2.936-.786zm1.84-2.22l.661 2.464 2.462-.66-3.122-1.804z"
            fillRule="nonzero"
            stroke="none"
        />
    </SvgIcon>
);

export default ReportsImage;
